// Basic
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';

// Modules
import { MaterialModule } from '@app/material.module';

// Components
import { MobileSubmenuDialogComponent } from './mobile-submenu-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MaterialModule
  ],
  declarations: [MobileSubmenuDialogComponent],
  exports: [MobileSubmenuDialogComponent],
  entryComponents: [MobileSubmenuDialogComponent]
})
export class MobileSubmenuDialogModule { }
